import axios from "../../config/axios";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  name: "SecuritySettings",
  data() {
    return {
      is2faEnabled: false,
    };
  },
  mounted() {
    axios.get("account/get-infor")
      .then(response => {
        if (response.data && response.data.status === '200' && response.data.result) {
          this.is2faEnabled = !!response.data.result.is2faEnabled;
        }
      })
      .catch(error => {
        console.error("Error loading 2fa setting:", error);
      });
  },
  methods: {
    update2faSetting() {
      axios.post("account/update-2fa-setting", {
        is2faEnabled: this.is2faEnabled
      })
      .then(response => {
        if (response.data.status === '200') {
          toast.success("Cập nhật cài đặt bảo mật thành công!");
        } else {
          toast.error(response.data.message || 'Lỗi khi cập nhật cài đặt bảo mật');
          // Revert on error
          this.is2faEnabled = !this.is2faEnabled;
        }
      })
      .catch(error => {
        console.error("Error updating 2fa:", error);
        toast.error("Có lỗi xảy ra khi gọi server.");
        // Revert on error
        this.is2faEnabled = !this.is2faEnabled;
      });
    }
  }
};
